import {
  REQUEST_DELETE_BEGIN,
  REQUEST_DELETE_SUCCESS,
  REQUEST_DELETE_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const requestDelete = () => async (dispatch, getState) => {
  dispatch({ type: REQUEST_DELETE_BEGIN });

  try {
    const response = await API({
      url: ENDPOINTS.REQUEST_DELETE,
      method: "POST",
      data: {
        deleteType: getState().deleteLineSelection,
        isReturnDelete: getState().downloadAndDelete.deleteRequestType ? true : false
      }
    });

    if (response && response.status === "OK") {
      dispatch({
        type: REQUEST_DELETE_SUCCESS,
        payload: response.data
      });
    } else {
      dispatch({ type: REQUEST_DELETE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    if (error.response && error.response.hasOwnProperty("description")) {
      dispatch({
        type: REQUEST_DELETE_FAILURE,
        payload: error.response.description
      });
    } else {
      dispatch({
        type: REQUEST_DELETE_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  }
};
